import { useState } from 'react';
import { Dialog, IconButton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Close from '@mui/icons-material/Close';
import { Post } from 'lib/types';
import { PostImg } from 'components/PostImg';
import { NetworkIcon } from 'elements/NetworkIcon';
import { PostSearch } from './PostSearch';

interface Props {
  posts: Post[];
  onChange: (p: Post[]) => void;
}

export const JobSelectPosts = ({
  posts, onChange,
}: Props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [isSearch, setIsSearch] = useState(false);

  if (isSearch) {
    return (
      <Dialog
        open
        onClose={() => setIsSearch(false)}
        maxWidth="xl"
        fullWidth
        fullScreen={isMobile}
      >
        <div className="absolute right-4 top-4">
          <IconButton onClick={() => setIsSearch(false)}>
            <Close />
          </IconButton>
        </div>
        <PostSearch
          selectedPosts={posts}
          onChange={onChange}
          onCancel={() => setIsSearch(false)}
          limit={3}
        />
      </Dialog>
    );
  }

  return (
    <div>
      <div className="mb-3">
        Select your favorite posts to share (Select up to 3)
      </div>
      <div>
        {posts.map((p) => (
          <div key={p.id} className="flex items-start overflow-hidden my-2">
            <div className="w-full flex items-center gap-4 max-h-28">
              <PostImg post={p} />
              <NetworkIcon network={p.network} iconColor="color" />
              <div className="font-semibold">
                @
                {p.account}
              </div>
            </div>
          </div>
        ))}
      </div>
      <div>
        <button
          id="add-posts"
          type="button"
          className="btn-primary-outlined"
          onClick={() => setIsSearch(true)}
        >
          {posts.length === 0 ? 'Add' : 'Update' }
          {' '}
          Posts
        </button>
      </div>
    </div>
  );
};
